// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__YcLoi","header":"MergedInvoice_header__3hfcx"};